import { makeStyles } from '@material-ui/core'
import {
    CLOUDINARY_NAME,
    getNetworkOverlayImageId,
} from '../../containers/CreateACard'
import { Image, Transformation } from 'cloudinary-react'
import { CARD_HEIGHT, CARD_WIDTH } from '../../constants'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
    cardPreviewWrapper: {
        position: 'relative',
        margin: '0 auto',
        '& img': {
            objectFit: 'contain',
            maxWidth: '100%',
            height: 'auto',
            boxShadow:
                '0 0px 2.1px rgba(0, 0, 0, 0.23), 0 0px 17px rgba(0, 0, 0, 0.46)',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: '0px',
        },
    },
    embossPreview: (props) => ({
        position: 'absolute',
        left: '9%',
        color: 'white',
        textShadow: 'rgb(0, 0, 0) 0px 0px 2px',
        top: '71%',
        fontSize: '26%',
        [theme.breakpoints.up(340)]: {
            fontSize: '32%',
        },
        [theme.breakpoints.up(400)]: {
            fontSize: '41%',
        },
        [theme.breakpoints.up('sm')]: {
            top: '74%',
            fontSize: '58%',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '60%',
        },
    }),
}))

const CardPreview = ({
    cloudinaryId,
    emboss1,
    emboss2,
    cardNetworkName,
    hideOverlay,
    imageClassName,
    showDynamicEmboss = false,
}) => {
    const classes = useStyles()

    const giftCardPreview = (
        <Image
            cloudName={CLOUDINARY_NAME}
            publicId={cloudinaryId}
            className={`${imageClassName}`}
            style={{
                backgroundColor: 'white',
            }}
            data-testid="card-image"
        >
            <Transformation color="black" effect="outline:outer:1:0" />
            <Transformation
                width={CARD_WIDTH}
                height={CARD_HEIGHT}
                crop="scale"
                fetchFormat="auto"
            />
            <Transformation quality="auto" />
            {!hideOverlay && (
                <Transformation
                    overlay={getNetworkOverlayImageId(cardNetworkName)}
                    flags="relative"
                    width="1.0"
                    height="1.0"
                />
            )}
            {!hideOverlay && !showDynamicEmboss && (
                <Transformation
                    color="white"
                    overlay={{
                        fontFamily: 'Arial',
                        fontSize: 14,
                        text: `${emboss1}%0A${emboss2}`,
                        stroke: 'stroke',
                    }}
                    flags="relative"
                    gravity="south_west"
                    x="0.1"
                    y="0.1"
                />
            )}
        </Image>
    )

    if (showDynamicEmboss) {
        return (
            <div className={classes.cardPreviewWrapper}>
                {giftCardPreview}
                <div className={classes.embossPreview}>
                    {emboss1 || 'RECIPIENT NAME'}
                    <br />
                    {emboss2}
                </div>
            </div>
        )
    }

    // No wrapper applied when showDynamicEmboss is false
    return giftCardPreview
}

CardPreview.propTypes = {
    cloudinaryId: PropTypes.string.isRequired,
    emboss1: PropTypes.string,
    emboss2: PropTypes.string,
    cardNetworkName: PropTypes.string.isRequired,
    hideOverlay: PropTypes.bool,
    imageClassName: PropTypes.string,
    showDynamicEmboss: PropTypes.bool,
}

export default CardPreview
